import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

/**
 * Where a control the plan leaves out would be (Export, Schedule…): a quiet
 * "Upgrade" chip in its place, with the same lock as the sidebar's locked
 * groups. The API refuses the action with `403 plan_feature_unavailable`
 * either way; this only saves the user a button that cannot work.
 */
export default function PlanLockedHint({ feature, label, className = "" }) {
  const { t } = useTranslation();
  const hint = t("plan.lockedHint", { feature: t(`plan.features.${feature}`) });

  return (
    <span
      title={hint}
      className={`inline-flex min-h-control items-center gap-1.5 rounded-control border border-dashed border-line-strong px-3 text-dense text-ink-2 ${className}`}
    >
      <LockClosedIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>{label ?? t(`plan.features.${feature}`)}</span>
      <span className="rounded-full bg-raised px-2 py-0.5 text-caption">{t("plan.upgradeBadge")}</span>
      <span className="sr-only">{hint}</span>
    </span>
  );
}

/** A one-line note on a screen the plan narrows (stock not tracked, one currency). */
export function PlanNote({ children, className = "" }) {
  return (
    <p
      className={`flex items-start gap-2 rounded-lg border border-line bg-raised px-3 py-2 text-dense text-ink-2 ${className}`}
    >
      <LockClosedIcon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
